import React from "react";
const SvgCaret = props => (
  <svg viewBox="0 0 12 7" {...props}>
    <path fill="none" stroke="#96A1B0" strokeWidth={1.4} d="M1 1l5 5 5-5" />
  </svg>
);
export default SvgCaret;
